export default "__VITE_ASSET__DUUguiq5__"